module.exports = __webpack_public_path__ + "img/arrow-left.666782ab.svg";